import React from "react";
import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getDeliveryArrangement } from "../../../redux/api/picking.api";

import {
  deliveryArrangementTableHeader,
  getDeliveryArrangementTableData,
} from "./components/tableConfigs/deliveryArrangementTableConfig";
import DeliveryArrangementActionButton from "./components/TableActionsButtonsComponents/DeliveryArrangementActionButton";
import { dateForDatabase } from "../../../utils/dateAndTime";
import ChangePickingDateForPackageModal from "./components/ChangePickingDateForPackageModal";

function DeliveryArrangement() {
  const dispatch = useAppDispatch();
  const {
    picking: {
      deliveryArrangement: {
        data: { nrTotal, orderPicking },
        isLoading: isLoadingDeliveryArrangement,
      },
    },
  } = useAppSelector((state) => ({
    picking: state.picking,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      const formatDate = dateForDatabase(action.tableSearch.createdAt);

      dispatch(
        getDeliveryArrangement({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          status: action.tableSearch?.status ?? 0,
          facturi: action.tableSearch?.facturi ?? "",
          ruta: action.tableSearch?.ruta ?? "",
          deliveryPoint: action.tableSearch?.deliveryPoint ?? "",
          commandNumber: action.tableSearch?.commandNumber ?? "",
          createdAt: formatDate,
        }),
      );
    }
  };

  return (
    <>
      <ChangePickingDateForPackageModal />

      <TableWidget
        tableTitle={"Dispozitii de livrare"}
        tableHeaderData={deliveryArrangementTableHeader}
        tableItemsData={getDeliveryArrangementTableData(orderPicking)}
        totalItems={nrTotal}
        borderedRow
        tableLoading={isLoadingDeliveryArrangement}
        ActionButtonsComponent={(props: any) => (
          <DeliveryArrangementActionButton {...props} />
        )}
        handleTableActions={handleTableActions}
      />
    </>
  );
}

export default DeliveryArrangement;
